var render = function render(){var _vm=this,_c=_vm._self._c;return _c('process-directory',{attrs:{"type":2,"title":"Falências","route-base":"/falencia"}})
}
var staticRenderFns = []

export { render, staticRenderFns }